// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2zRul","title":"Header_title__2Nmrh","side":"Header_side__cLgCH"};